import React from "react";
import styles from "../Input/TextField/TextField.module.css";

export default function FormSection({ title }) {
  return (
    <>
      <h2 className={styles.sectionTitle}>{title}</h2>
    </>
  );
}
